import { render, staticRenderFns } from "./AppointModal.vue?vue&type=template&id=46bbf662&scoped=true&"
import script from "./AppointModal.vue?vue&type=script&lang=js&"
export * from "./AppointModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bbf662",
  null
  
)

export default component.exports